import axios from 'axios';
import _settings from '../_settings';

const remote =	_settings.remote+"/pages?orderby=menu_order&order=asc";


const navData = [];
export function getNavigation(){

	return function(dispatch) {

		dispatch({ type: "GETTING_NAVIGATION" })


		axios.get(remote).then((response) => {

				
			return(
				dispatch({ type: "GOT_NAVIGATION", payload: response.data })	
			);
		})

	}


}






// WEBPACK FOOTER //
// ./src/js/actions/Navigation.js